export default __webpack_public_path__ + "static/LAURA-GALLEGO-UN-PUNTO-QUE-FLORECE-721db93b33246380c9f2648420eddd1d.png";